export const config = {
  endpoints: {
    fetchBrands: '/brands/index/getbrands',
    fetchLaunches: '/launches_frontend/campaign/get',
  },
};
